import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'

export const RecoParcoursProspect = ({ title, cacheKey, items }) => {
   useLayoutEffect(() => {
      setAllToMaxHeight('#recoParcoursProspect .btn-custom-height')
   }, [])

   return (
      <div id="recoParcoursProspect" class="container-fluid">
         <div class="row bande_offre-marchand-prospect" data-testid="bande-offre-marchand" data-cache-key={cacheKey}>
            <div class="col-12">
               <h2 class="mb-2 mb-xl-3">{title}</h2>
            </div>
            <div class="col-12">
               <ul class="row mb-0 list-unstyled">
                  {items.map((item, index) => {
                     return (
                        <li class="col-12 col-sm-4 mb-2 mb-xl-3">
                           <div
                              class="reco-parcours-prospect ob1-card d-flex flex-column h-100 lien-composite"
                              data-testid={`marchand_offre${index + 1}`}
                              data-pdb-zid={item.CTA.analytics.pdbZid}
                              data-pdb-sc={item.CTA.analytics.pdbSc}
                              data-pdb-idc={item.CTA.analytics.pdbIdc}
                              data-pdb-vi={item.CTA.analytics.pdbVi}
                              data-oevent-category={item.CTA.analytics.oeventCategory}
                              data-oevent-action={item.CTA.analytics.oeventAction}
                              data-oevent-label={item.CTA.analytics.oeventLabel}
                              data-oevent-other={item.CTA.analytics.oeventOther}
                           >
                              {item.badge && item.badge !== '' ? <div class="ob1-tag ob1-tag-primary">{item.badge}</div> : ''}

                              <div class="img text-center mb-2">
                                 <picture>
                                    <source srcset={`${item.image}?saveas=webp&format=270x180`} media="(max-width: 959px)" />
                                    <source srcset={`${item.image}?saveas=webp&format=335x224`} media="(max-width: 1199px)" />
                                    <img loading="lazy" src={`${item.image}?saveas=webp&format=405x270`} alt="" class=" mw-100" />
                                 </picture>
                              </div>

                              <div class="content h-100 d-flex flex-column">
                                 <h3 class="title pb-0 mb-1">{item.title}</h3>
                                 <p class="description pt-0">{item.description}</p>
                                 <a
                                    href={item.CTA.URL}
                                    aria-label={`${item.CTA.label} : ${item.CTA.ariaLabel}`}
                                    class="btn btn-secondary mt-auto align-self-center btn-custom-height d-flex"
                                    target={item.CTA.target}
                                 >
                                    <span>{item.CTA.label}</span>
                                 </a>
                              </div>
                           </div>
                        </li>
                     )
                  })}
               </ul>
            </div>
         </div>
      </div>
   )
}
